// Selectors
import { useQueryClient } from "@tanstack/react-query";
import { useCatalogsStore } from "stores/catalogs";

// Utils

const useTranslate = () => {
  const localization = useCatalogsStore((state) => state.localization);
  const queryClient = useQueryClient();

  const localizationEng = queryClient.getQueryData(["localizationEng"]);

  return (key: string | null): string => {
    if (!key) {
      return "";
    }

    if (!localization) {
      // // eslint-disable-next-line no-console
      // console.error("Localization data is not available");
      return key;
    }

    const translation = localization && localization[key];
    const englishTranslation = localizationEng && localizationEng[key];

    if (translation === "" || !translation) {
      if (englishTranslation) {
        return englishTranslation;
      }

      return key;
    }

    if (!translation) {
      return key;
    }

    return translation;
  };
};

export default useTranslate;
